// src/components/CardDetails.js
import React, { useEffect, useState } from 'react';
import './CardDetails.css';

function CardDetails({ card }) {
  const [faqList, setFaqList] = useState([]);
  const [isFaqOpen, setIsFaqOpen] = useState(false);

  const [synergyList, setSynergyList] = useState([]);
  const [isPlusOpen, setIsPlusOpen] = useState(true);   // プラス効果開閉
  const [isMinusOpen, setIsMinusOpen] = useState(true); // マイナス効果開閉

  const defaultCard = {
    card_id: null,
    card_image: 'no_image.JPG',
    card_name: 'No Card Selected',
    card_type_name: 'N/A',
    element_code: 'N/A',
    element_name: 'N/A',
    description: 'No description available.',
  };

  const displayCard = card || defaultCard;

  // FAQ取得
  useEffect(() => {
    if (!displayCard.card_id) return;

    fetch(`/api/faq?card_id=${displayCard.card_id}`)
      .then((res) => res.json())
      .then((data) => setFaqList(data))
      .catch(() => setFaqList([]));
  }, [displayCard.card_id]);

  // シナジーカード取得
  useEffect(() => {
    if (!displayCard.card_id) return;

    fetch(`/api/synergy?card_id=${displayCard.card_id}`)
      .then((res) => res.json())
      .then((data) => setSynergyList(data))
      .catch(() => setSynergyList([]));
  }, [displayCard.card_id]);

  const plusCards = synergyList.filter(c => c.plus_minus_flag === '0');
  const minusCards = synergyList.filter(c => c.plus_minus_flag === '1');

  return (
    <div className="card-details-container">
      <h2 className="cd-title">カード詳細</h2>

      <div className="cd-content">
        <div className="cd-image">
          <img
            src={`${process.env.PUBLIC_URL}/assets/${displayCard.card_image}`}
            alt={displayCard.card_name}
          />
        </div>

        <div className="cd-info">
          <p><strong>カード名称:</strong> {displayCard.card_name}</p>
          <p><strong>種別:</strong> {displayCard.card_type_name}</p>
          <p><strong>属性:</strong> {displayCard.element_name}</p>
          <p>
            <strong>効果: </strong>
            <span
              dangerouslySetInnerHTML={{
                __html: displayCard.description.replace(/ +/g, "<br/>　　  ")
              }}
            />
          </p>
        </div>
      </div>

      {/* FAQ */}
      <div className="faq-section">
        <h3
          className={`faq-header ${isFaqOpen ? "open" : ""}`}
          onClick={() => setIsFaqOpen(!isFaqOpen)}
        >
          FAQ ({faqList.length})
        </h3>

        {isFaqOpen && (
          <div className="faq-list">
            {faqList.length === 0 && <p>FAQはありません</p>}
            {faqList.map((faq, index) => (
              <p key={faq.faq_id}>
                <a href={faq.url} target="_blank" rel="noopener noreferrer">
                  FAQ{index + 1}
                </a>
              </p>
            ))}
          </div>
        )}
      </div>

      {/* プラス／マイナス効果カード */}
      <div className="synergy-section">
        <h3
          className="synergy-header"
          onClick={() => setIsPlusOpen(!isPlusOpen)}
        >
          プラス効果カード一覧 ({plusCards.length})
        </h3>
        {isPlusOpen && (
          <div className="synergy-cards">
            {plusCards.length === 0 ? <p>なし</p> :
              plusCards.map(c => (
                <img
                  key={c.cynergy_card_id}
                  src={`${process.env.PUBLIC_URL}/assets/${c.card_image}`}
                  alt={c.card_name}
                  title={c.card_name}
                  className="synergy-card-img"
                />
              ))
            }
          </div>
        )}

        <h3
          className="synergy-header"
          onClick={() => setIsMinusOpen(!isMinusOpen)}
        >
          マイナス効果カード一覧 ({minusCards.length})
        </h3>
        {isMinusOpen && (
          <div className="synergy-cards">
            {minusCards.length === 0 ? <p>なし</p> :
              minusCards.map(c => (
                <img
                  key={c.cynergy_card_id}
                  src={`${process.env.PUBLIC_URL}/assets/${c.card_image}`}
                  alt={c.card_name}
                  title={c.card_name}
                  className="synergy-card-img"
                />
              ))
            }
          </div>
        )}
      </div>
    </div>
  );
}

export default CardDetails;
